/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business PJ Sandbox で未配置ブロック（トレイ）を候補案件プールの週セクションへドロップしたときの、SandboxBlock → CandidateCase 変換（name→title の写像・placement/sourceCandidateId の破棄・週インデックスの付与）を担う純粋関数
 * @graph-connects none
 */
import type { CandidateCase, SandboxBlock } from './types.js';

/**
 * 未配置ブロックを、指定した週の候補案件へ変換する。
 * 白板配置に固有のフィールド（placement / sourceCandidateId）は引き継がず、
 * name は候補案件の title へ写像する。Backlog 課題キーは白板配置に固有ではないため、
 * 候補へ戻しても Backlog リンクを失わないよう引き継ぐ。
 *
 * `teamKey` は変換先（候補案件プールを持つ表示中のチーム）を渡す。共有トレイのブロックは
 * `teamKey` が共有トレイの固定値のままなので、`block.teamKey` を引き継ぐと候補が
 * 存在しない疑似チーム key を持ってしまう。候補プールはチーム白板の持ち物なので、
 * 持ち主のチーム key を明示的に付ける。
 *
 * @graph-connects none
 */
export function blockToCandidate(
  block: SandboxBlock,
  weekIndex: number,
  candidateId: string,
  teamKey: string,
): CandidateCase {
  return {
    id: candidateId,
    title: block.name,
    sizePt: block.sizePt,
    kind: block.kind,
    teamKey,
    weekIndex,
    ...(block.issueKey === undefined ? {} : { issueKey: block.issueKey }),
  };
}
